var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24PxIconWhatsapp = function Svg24PxIconWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 12a8.5 8.5 0 1 1 3.958 7.186 1 1 0 0 0-.82-.113l-2.881.859 1.085-2.537a1 1 0 0 0-.07-.92A8.456 8.456 0 0 1 3.5 12ZM12 1.5C6.201 1.5 1.5 6.201 1.5 12c0 1.838.473 3.568 1.305 5.073L1.08 21.107a1 1 0 0 0 1.206 1.351l4.5-1.342A10.455 10.455 0 0 0 12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.8 1.5 12 1.5Zm2.293 12.682-1.315.926A9.332 9.332 0 0 1 11 13.585a10.2 10.2 0 0 1-1.624-2.114l.835-.709a1 1 0 0 0 .236-1.232l-1.064-2a1 1 0 0 0-1.54-.283l-.316.275c-.759.662-1.208 1.75-.836 2.852A12.05 12.05 0 0 0 9.586 15c1.813 1.813 3.655 2.527 4.733 2.805.868.223 1.69-.076 2.268-.548l.591-.482a1 1 0 0 0-.12-1.634l-1.678-1a1.001 1.001 0 0 0-1.088.041h.001Z",
    fill: "#25D366"
  })));
};
export default Svg24PxIconWhatsapp;